import gql from "graphql-tag";

export default gql`mutation CreateHolidayPaystub($holidayWorkerId: Int!) {
    createHolidayPaystub(holidayWorkerId: $holidayWorkerId)
  }`;
